import { $color_grey_2, $color_brand_light_bg_default, $color_grey_6 } from '../pebbleGlobalToken/color.js';

/**
 * 下拉菜单-控制组件项在鼠标悬浮时的背景颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $dropdown_control_item_bg_hover = $color_grey_2;

/**
 * 下拉菜单-控制组件项在激活状态下的背景颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_light_bg_default
 */
var $dropdown_control_item_bg_active = $color_brand_light_bg_default;

/**
 * 下拉菜单-控制禁用状态下的字体颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-6
 */
var $dropdown_color_text_disabled = $color_grey_6;

export { $dropdown_color_text_disabled, $dropdown_control_item_bg_active, $dropdown_control_item_bg_hover };
